import { joinDataTestId } from "@/constants/data-test-ids.utils";

export const appointmentCalendarDataTestIds = {
  component: "appointment-calendar" as const,
  container: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "container"),
  // Bannière de filtre
  providerFilterBanner: (): string =>
    joinDataTestId(appointmentCalendarDataTestIds.component, "provider-filter-banner"),
  providerFilterIcon: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "provider-filter-icon"),
  providerFilterTitle: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "provider-filter-title"),
  providerFilterDescription: (): string =>
    joinDataTestId(appointmentCalendarDataTestIds.component, "provider-filter-description"),
  toggleProviderFilterBtn: (): string =>
    joinDataTestId(appointmentCalendarDataTestIds.component, "toggle-provider-filter-btn"),
  // Navigation des semaines
  weekNavigationContainer: (): string =>
    joinDataTestId(appointmentCalendarDataTestIds.component, "week-navigation-container"),
  prevWeekBtn: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "prev-week-btn"),
  nextWeekBtn: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "next-week-btn"),
  weekChipsContainer: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "week-chips-container"),
  // Grille de la semaine
  weekGrid: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "week-grid"),
  // Panneau de confirmation
  selectionPanel: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "selection-panel"),
  selectionIcon: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "selection-icon"),
  selectionLabel: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "selection-label"),
  selectionDetails: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "selection-details"),
  confirmBtn: (): string => joinDataTestId(appointmentCalendarDataTestIds.component, "confirm-btn"),
};
